import { useLazyUser } from "$global-providers/user-provider";
import { linkToHome } from "$routes/_lib/links";
import { linkToEpocusHome } from "$routes/epocus/links";
import { linkToPatientQueue } from "$routes/patient-queue-management/links";
import { linkToScanCard } from "$routes/scan-card/links";
import { linkToWardPatientList } from "$routes/ward-patient-list/links";
import { Role } from "elephant-web/gql";
import { type Location, Navigate } from "react-router-dom";
import { useLocationHistoryContext } from "../global-providers/location-history/provider";
import { linkToAdminControlPanel } from "./admin/links";
import { linkToPatientSearch } from "./patient-search/links";
import { linkToLogin } from "./user/links";

const ROLE_HOMEPAGES: Record<Role, { path: string }> = {
  [Role.Root]: {
    path: linkToAdminControlPanel(),
  },
  [Role.Admin]: {
    path: linkToAdminControlPanel(),
  },
  [Role.CashOfficer]: {
    path: linkToPatientSearch(),
  },
  [Role.Clinic]: {
    path: linkToPatientSearch(),
  },
  [Role.DataExporter]: {
    path: linkToAdminControlPanel(),
  },
  [Role.Doctor]: {
    path: linkToPatientSearch(),
  },
  [Role.Elephant]: {
    path: linkToAdminControlPanel(),
  },
  [Role.Nurse]: {
    path: linkToPatientSearch(),
  },
  [Role.Pharmacist]: {
    path: linkToPatientSearch(),
  },
  [Role.Technician]: {
    path: linkToPatientSearch(),
  },
  [Role.Dispenser]: {
    path: linkToPatientSearch(),
  },
  [Role.Sonographer]: {
    path: linkToPatientSearch(),
  },
  [Role.Performer]: {
    path: linkToEpocusHome(),
  },
  [Role.Reviewer]: {
    path: linkToEpocusHome(),
  },
  [Role.QaAdmin]: {
    path: linkToEpocusHome(),
  },
  [Role.ProgramAdmin]: {
    path: linkToEpocusHome(),
  },
};

const HIGH_PRIORITY_ROUTES = [
  linkToPatientSearch(),
  linkToPatientQueue(),
  linkToScanCard(),
  linkToWardPatientList(),
];

const useLastHighPriorityLocationVisted = (): Location | undefined => {
  const { locationHistory } = useLocationHistoryContext();

  return (
    locationHistory
      // Latest first
      .reverse()
      // Filter in case we came via replace
      .filter((l) => l.pathname !== linkToHome())
      // Exclude the most recent location as that is how we got here.
      .slice(1)
      .find((l) => HIGH_PRIORITY_ROUTES.includes(l.pathname))
  );
};

export const HomePage: FC = () => {
  const user = useLazyUser();
  const lastHighPriorityLocation = useLastHighPriorityLocationVisted();
  if (!user) {
    return <Navigate to={linkToLogin()} replace />;
  }
  const userHomepage = user.role
    ? ROLE_HOMEPAGES[user.role].path
    : linkToEpocusHome();

  return (
    <Navigate
      to={lastHighPriorityLocation ?? userHomepage}
      state={lastHighPriorityLocation?.state}
      replace
    />
  );
};
